import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [{
        path: "/",
        alias: "/home",
        name: "home",
        component: () => import("../components/Home")
    }, {
        path: "/Pricing",
        alias: "/pricing",
        name: "Pricing",
        component: () => import("../components/Pricing")
    }, {
        path: "/Privacy",
        alias: "/privacy",
        name: "Pricing",
        component: () => import("../components/Privacy")
    }, {
        path: "*",
        name: "Home",
        component: () => import("../components/Home")
    }]
})

export default router
